import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Notice, Separator } from 'telia-front-react';
import { useStores } from '../../stores/RootStore';
import { FetchStatus } from '../../util/FetchStatus';
import CancelReservation from '../CancelReservation';
import ReservationView from './ReservationView';

const ChildStoreReservationAdministration = observer((): React.JSX.Element => {
  const {
    reservationStore: { reservation, reservationCancelStatus }
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  return (
    <>
      {reservation?.stateCode === 'USED' && <Notice type="success">{translate('reservation.store.administration.notice.used')}</Notice>}
      <ReservationView />
      <Separator spacing="small" weight="thin" />
      {reservationCancelStatus !== FetchStatus.FETCHED && (
        <>
          <p>{translate('reservation.store.administration.cancel.text')}</p>
          <Separator spacing="xxsmall" color="invisible" />
        </>
      )}
      <CancelReservation />
    </>
  );
});

export default ChildStoreReservationAdministration;
